module.exports = __webpack_public_path__ + "static/media/laddu_under_tree.4e5ab3b7.gif";